(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["depict-patched-main-collection"]) return;
  try {
      const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["okan-launch-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('okan-launch-countdown')) {
    customElements.define(
      'okan-launch-countdown',
      class extends HTMLElement {
        connectedCallback() {
          clearInterval(this.interval);

          const raw = this.dataset.deadline || '';

          const format =
            /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|[+-]\d{2}:\d{2})$/;

          this.deadline = format.test(raw)
            ? Date.parse(raw)
            : NaN;

          const valid = Number.isFinite(this.deadline);
          const warning = this.querySelector('[data-config-error]');

          if (warning) {
            warning.hidden = valid;
          }

          this.querySelector('[data-timer]').hidden = !valid;
          this.querySelector('[data-pending]').hidden = valid;

          if (!valid) return;

          const tick = () => {
            const remaining = Math.max(
              0,
              Math.ceil((this.deadline - Date.now()) / 1000)
            );

            const values = {
              days: Math.floor(remaining / 86400),
              hours: Math.floor(remaining / 3600) % 24,
              minutes: Math.floor(remaining / 60) % 60,
              seconds: remaining % 60
            };

            for (const [unit, value] of Object.entries(values)) {
              this.querySelector(
                `[data-${unit}]`
              ).textContent = String(value).padStart(2, '0');
            }

            if (remaining === 0) {
              this.querySelector('[data-timer]').hidden = true;
              this.querySelector('[data-pending]').hidden = false;
              clearInterval(this.interval);
            }
          };

          this.interval = setInterval(tick, 1000);
          tick();
        }

        disconnectedCallback() {
          clearInterval(this.interval);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
